import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import API from "../../../../actions/api-helper";
import UI from "../../../../actions/ui-helper";

import AuditoriaTopico from "./AuditoriaTopico";
import AuditoriaObservacao from "./AuditoriaObservacao";

class AuditoriaReuniao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      versaoId: 0,
      reuniao: false,
    };
    if (this.props.match) {
      this.state.entidadeId = this.props.match.params.id;
    }
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    UI.loader("show", "Carregando histórico...");
    API.get("/historico/Reuniao/" + this.state.entidadeId)
      .then(
        (json) => {
          if (json.data.length > 0) {
            let versaoId = json.data.length - 1;
            let versao = json.data[versaoId].instancia;
            this.setState({ versaoId: versaoId, historico: json.data, reuniao: versao });
          }
          else {
            UI.alert(false, "Esta reunião não teve auditoria.");
          }
          UI.loader("hide");
        })
      .catch(
        (json) => {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
  }

  handleChange(event) {
    let versaoId = parseInt(event.target.value);
    let versao = this.state.historico[versaoId].instancia;
    this.setState({ [event.target.name]: event.target.value, reuniao: versao });
  }

  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    let styleSelecao = {
      border: "1px solid #777",
      borderWidth: "1px 1px 0px 1px",
      color: "rgb(0,0,150)",
      fontWeight: "700",
      background: "#ddd"
    }

    if (!this.state.reuniao) return false;
    let reuniao = this.state.reuniao;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6 text-right">
            <select
              style={styleSelecao}
              name="versaoId"
              className="form-control"
              value={this.state.versaoId}
              onChange={this.handleChange}
            >
              {this.state.historico.map((versao, i) => {
                return (
                  <option key={i} value={i}>Versão #{i + 1} - {versao.dataHora} - {versao.usuario.nome}</option>
                );
              })}
            </select>
          </div>
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">AUDITORIA DA REUNIÃO #{reuniao.id}</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/reuniao/cadastro/" + reuniao.id) }}
                      className="btn btn-info">
                      <i className="fa fa-edit"></i>&nbsp;Editar
                      </button>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Cód / Procedimento</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="descricao"
                      className="form-control"
                      value={reuniao.procedimento.codigo + " - " + reuniao.procedimento.descricao}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Participantes</label>
                    <div className="badge-background">
                      {reuniao.valores.length === 0 &&
                        <div className="badge badge-none">Nenhum profissional foi selecionado...</div>}
                      {reuniao.valores.map((valor) => {
                        return (<div
                          key={valor.usuarioId}
                          className="badge badge-warning badge-remove"><i className="icon icon-user"></i>&nbsp;{valor.usuarioNome}</div>)
                      })}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Data</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="data"
                      className="form-control"
                      mask="99/99/9999"
                      value={reuniao.data}
                      onChange={this.handleChangeReuniao}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Hora Entrada</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="horaEntrada"
                      className="form-control"
                      mask="99:99"
                      value={reuniao.horaEntrada}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Hora Saída</label>
                    <InputMask
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="horaSaida"
                      className="form-control"
                      mask="99:99"
                      value={reuniao.horaSaida}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Reunião</label>
                    <select
                      style={styleContraste}
                      disabled
                      name="tipo"
                      className="form-control"
                      value={reuniao.tipo}
                      onChange={this.handleChangeReuniao}
                    >
                      <option value={1}>CONFIRMADA</option>
                      <option value={2}>CANCELADA</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-12">
                    <label>Pauta</label>
                    <input
                      style={styleContraste}
                      disabled
                      placeholder="NÃO INFORMADO"
                      name="pauta"
                      className="form-control"
                      value={reuniao.pauta}
                      onChange={this.handleChangeReuniao}
                    />
                  </div>
                </div>
              </div>
            </div >
          </div >
        </div >
        <AuditoriaTopico
          topicos={reuniao.topicos}
        />
        <AuditoriaObservacao
          observacoes={reuniao.observacoes}
        />
      </React.Fragment >
    );
  }
}

export default withRouter(AuditoriaReuniao);